import React from 'react';
import {
  Container,
  Header,
  SpaceBetween,
  Button,
  Box,
  Spinner
} from '@cloudscape-design/components';
import { useStrings } from '../hooks/useConfig';

export const NotFound: React.FC = () => {
  const { strings, loading } = useStrings();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spinner size="large" />
      </div>
    );
  }

  const title = strings?.notFound.title || 'Page Not Found';
  const code = strings?.notFound.code || '404';
  const message = strings?.notFound.message || 'The folder you\'re looking for doesn\'t exist or you don\'t have access to it.';
  const goHome = strings?.notFound.goHome || 'Go to Home';

  return (
    <Container
      header={
        <Header variant="h1">
          {title}
        </Header>
      }
    >
      <SpaceBetween direction="vertical" size="l">
        <Box textAlign="center">
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>{code}</div>
          <div style={{ fontSize: '18px', color: '#666', marginBottom: '24px' }}>
            {message}
          </div>
          <Button
            variant="primary"
            onClick={() => window.location.href = '/'}
          >
            {goHome}
          </Button>
        </Box>
      </SpaceBetween>
    </Container>
  );
};